<script>
  import { generateRandomId } from '../utils/IdentifierGenerator.js';

  /**
 *
 *
 */
  /**
 *
 */

  let { energyEfficiencyClasses } = $props();
  let randomSheetId = generateRandomId();
</script>

<div class="reco_comparison__multi-eek-container">
  <div class="reco_comparison__article-eek-container reco_comparison__article-eek">
    {#each energyEfficiencyClasses as energyEfficiencyClass, index}
      <div class="reco_comparison__article-eek-label oc-mt-25">
        <oc-sheet-v1
          id="{energyEfficiencyClass?.component}-{index}-{randomSheetId}"
          oc-aria-label="default sheet without label">
          <h3 slot="headline" class="oc-headline-100">
            Energieeffizienzklasse {energyEfficiencyClass.component}
          </h3>
          {#if !energyEfficiencyClass.images[0].uriTemplate}
            <div class="reco_comparison__article-eek-layer-container">
              <p class="p_copy100">
                Aktuell stehen leider keine weiteren Informationen zur Energieeffizienzklasse dieses
                Artikels zur Verfügung.
              </p>
            </div>
          {:else}
            <div class="">
              {#if energyEfficiencyClass.component || energyEfficiencyClass.dataSheetHref}
                <div class="pl_sheet__content" style="max-height: calc(-160px + 100vh);">
                  <div class="reco_comparison____sheet-image-container">
                    <img
                      class="reco_comparison__sheet-image"
                      src={energyEfficiencyClass.images[0].uriTemplate}
                      alt="Energieeffizienzklasse: " />
                  </div>
                </div>
                {#if energyEfficiencyClass.dataSheetHref}
                  <oc-button-v1
                    variant="secondary"
                    target="_blank"
                    size="100"
                    base64-href={btoa(energyEfficiencyClass.dataSheetHref)}>
                    <a href={energyEfficiencyClass.dataSheetHref}>Produktdatenblatt (PDF)</a>
                  </oc-button-v1>
                {/if}
              {/if}
            </div>
          {/if}
        </oc-sheet-v1>
        <oc-interactive-overlay-v1
          data-oc-sheet-v1-open
          data-oc-sheet-v1-open.id="{energyEfficiencyClass.component}-{index}-{randomSheetId}"
          oc-aria-label="TODO - Click to see specifications">
          <oc-energy-label-v1
            class="reco_comparison__article-eek-label-img"
            color={energyEfficiencyClass.colorHexCode}
            size="100"
            variant={energyEfficiencyClass.category}
            version={energyEfficiencyClass.uniform ? 'uniform' : 'default'}></oc-energy-label-v1>
        </oc-interactive-overlay-v1>

        {#if energyEfficiencyClass.dataSheetHref}
          <div class="reco_comparison__article-eek-label_energyLabelText">
            {#if energyEfficiencyClass.displayName}
              <span
                class="oc-copy-50 reco_comparison__article-eek-label_energyLabelText_energyLabelTextComponent">
                {energyEfficiencyClass.displayName}
              </span>
            {/if}
            <oc-link-v2
              variant="secondary"
              class="reco_comparison__article-eek-label_energyLabelText_datasheet"
              size="50">
              <a
                href={energyEfficiencyClass.dataSheetHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="some-description">
                Produktdatenblatt
              </a>
            </oc-link-v2>
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  .reco_comparison__article-eek-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .reco_comparison__article-eek-label {
    white-space: nowrap;
    display: flex;
    align-items: center;
    width: 100%;

    &_energyLabelText {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: calc(100% - 40px);

      &_energyLabelTextComponent {
        cursor: default;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-left: 4px;
        width: 100%;
      }

      &_datasheet {
        margin-left: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .reco_comparison__article-eek-label:first-of-type {
    margin-top: unset !important;
  }

  :global(.reco_comparison__article-eek-layer-container) {
    margin: 16px auto;
    text-align: center;

    :global(.reco_comparison__article-eek-layer-title) {
      font-weight: 400;
      font-size: 20px;
      text-align: left;
      padding-left: 16px;
    }

    :global(.reco_comparison__article-eek-layer-datasheet) {
      text-align: left;
      display: block;
      padding-left: 16px;
    }

    :global(.reco_comparison__article-eek-layer-label) {
      margin-bottom: 16px;
    }

    :global(.reco_comparison__article-eek-layer-labels-container) {
      margin-bottom: 24px;
    }
  }

  .reco_comparison____sheet-image-container {
    display: flex;
    justify-content: center;
  }

  .reco_comparison__sheet-image {
    width: 100%;
  }
</style>
